import { IGetState } from '../types/types';
import { Dispatch, ThunkAction } from '../types/actions';
import { getMessages, root } from '../store/constants';
import { getActiveBoard } from '../store/model/selectors/getActiveBoard';

export const openListViewSettings = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const board = getActiveBoard(state);
        if (board) {
            if (state.listView) {
                root.App.controller.asidePanel.showListViewSettings();
            } else {
                root.App.router.navigate(root.App.router.getUrl(), { trigger: false });
            }
        } else {
            root.App.controller.showError(getMessages().getText('error.record.not_found'));
        }
    };
    return action;
}
